import React from "react";
import "./Signup.css";
import FadeIn from "react-fade-in";

//Class to display "Hjelp" button on the seat reservation menu
//Shows modal of legend

export class BlacklistModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {}
    };
  }

  componentWillMount() {
    console.log(this.props.data);
  }

  render() {
    const info = (
      <div className="infoModal">
        <h3>Du har blitt blokkert</h3>
        <br />
        <h6>
          <b>Bruker av epost:</b> {this.props.data[0].email} kan ikke lenger
          melde seg på.
        </h6>{" "}
        <br />
        <h6>
          <b>Årsak:</b> {this.props.data[0].publicCause}
        </h6>
        <br />
        <h6>For å fjerne sperringen, ta kontakt på epost eller Messenger</h6>
        <br />
      </div>
    );

    return (
      <div className="seatModal">
        <FadeIn>
          {info}
          <div className="btnSpace">
            <button
              className="btn btno btn-danger help"
              onClick={this.props.closeBlackListedModal}
            >
              {" "}
              Tilbake{" "}
            </button>
          </div>
        </FadeIn>
      </div>
    );
  }
}

export default BlacklistModal;



// WEBPACK FOOTER //
// ./src/Components/Signup/BlacklistModal.js